<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>DEAN R&D</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Dean R&D</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02 py-6">
    <div class="container py-3">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 ">
                <img src="assets/img/chancellor/7.jpeg" class="img-fluid w-100 object-fit-cover">
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-center text-md-start mb-0">
                    <span class="sub-title">Dean R&D Message</span>
                </div>
                <h2 class="h1  text-primary text-center text-md-start">Dean R&D</h2>
                <p class="px-2" align="justify">I am delighted to extend a warm welcome to all students, faculty, researchers, and partners who share
                    in our commitment to advancing knowledge and fostering innovation. As the Dean of Research and
                    Development, it is my honor to convey our dedication to pushing the boundaries of discovery and
                    contributing to the betterment of society.</p>

                <p class="px-2" align="justify">Research lies at the heart of our academic institution, driving progress and shaping the future. Our
                    faculty members are at the forefront of their respective fields, conducting groundbreaking research
                    that addresses complex challenges and opens new avenues for exploration. We take pride in nurturing
                    a culture of intellectual curiosity, collaboration, and excellence.</p>
                <div class="section-heading text-start mb-0 mt-3">
                    <span class="sub-title text-secondary">Prof. (Dr.) Neeraj Bhandari (Dean R&D)</span>
                </div>
            </div>
            <div class="col-lg-12 col-xl-12 ">
                <p class="px-2" align="justify">At Arni University, we believe that research is a collaborative and interdisciplinary endeavor. By
                    fostering a dynamic environment that encourages the exchange of ideas across disciplines, we aim to
                    address the multifaceted issues facing our world today. Our research initiatives span a wide range
                    of fields, from fundamental sciences to applied technologies, social sciences, and humanities.</p>
                <p class="px-2" align="justify">As we embark on this exciting journey of discovery, our commitment extends to supporting and
                    empowering our students. We believe that research is not only about producing knowledge but also
                    about providing a transformative learning experience. Through engaging in research projects, our
                    students develop critical thinking skills, creativity, and a deep understanding of their chosen
                    fields.</p>
                <p class="px-2" align="justify">Our partnerships with industry, government agencies, and other academic institutions further amplify
                    the impact of our research. Together, we strive to create solutions that address real-world
                    challenges, foster innovation, and contribute to the advancement of society.</p>

                <p class="px-2" align="justify">I invite you to explore our research initiatives, collaborations, and the diverse expertise of our
                    faculty and researchers. Your involvement, whether as a student, collaborator, or supporter, is
                    crucial to the success of our research endeavors.</p>

                <p class="px-2" align="justify">Thank you for being part of our vibrant research community. Together, let us continue pushing the
                    boundaries of knowledge and making a positive impact on the world.</p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
